<app-breadcrumb [root]="breadcrumb.root" [whereThis]="breadcrumb.whereThis" append="Array"></app-breadcrumb>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container">
    <div fxLayout="row" fxLayoutGap="20px" *ngIf="f.name.enabled">
      <div fxFlex="45">
        <mat-form-field class="ps-input" appearance="fill">
          <mat-label>Atributo</mat-label>
          <input matInput formControlName="name" required>
          <mat-error *ngIf="f.name.hasError('required')">
            Campo obrigatório
          </mat-error>
          <mat-error *ngIf="f.name.hasError('keyAlreadyExists')">
            Esse nome já está sendo utilizado
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="send-value" fxLayout="column" fxLayoutGap="20px">
      <json-template-array
          fxFlex
          [_index]="0"
          [data]="f.value.value"
          [name]="f.name.value"
          [configHeader]="configHeader"
          [isOpen]="true"
          [breadcrumb]="breadcrumb"
          (deleteAllEvent)="deleteAllEvent($event)"
          *ngIf="hasItems">
      </json-template-array>
      <json-template-button-add-attribute 
        fxFlex 
        [config]="configButtonAddAttribute"
        (addAttributeEvent)="addAttribute($event)">
      </json-template-button-add-attribute>
    </div>
    <app-save-dialog [form]="form"></app-save-dialog>
  </div>
</form>
